import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';
import FieldErrorMessage from '../FieldErrorMessage';
import HintWarranty from "../HintWarranty";

const InputWarranty = (props ) => {
    // eslint-disable-next-line react/prop-types
  const { label, name, type, defaultValue, isRequired, rules, hint, min  } = props;
  const { register, unregister } = useFormContext();

    useEffect( () => {
        return () => {
            unregister( name )
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [] );

  return (
    <div className={`form-item form-item--input`}>
      <label htmlFor={name}>
        {label}
        {hint && <HintWarranty hint={hint}/>}
        {isRequired && <span className="required">*</span>}
      </label>
      <input
        id={name}
        type={type}
        name={name}
        required={isRequired}
        ref={register(rules)}
        defaultValue={defaultValue}
        min={min}
      />
      <FieldErrorMessage name={name} />
    </div>
  );
};

InputWarranty.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  defaultValue: PropTypes.string,
  isRequired: PropTypes.bool,
  rules: PropTypes.objectOf(PropTypes.any),
};

InputWarranty.defaultProps = {
  type: 'text',
  isRequired: true,
  rules: null,
  defaultValue: null,
};

export default InputWarranty;
